import { render } from "./ProductCard.vue?vue&type=template&id=f2d4153e"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/bundle-builder/components/ProductCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2d4153e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2d4153e', __exports__)) {
    api.reload('f2d4153e', __exports__)
  }
  
  module.hot.accept("./ProductCard.vue?vue&type=template&id=f2d4153e", () => {
    api.rerender('f2d4153e', render)
  })

}


export default __exports__